/**
 * 複数の画面から使う共通クエリ。
 *
 * 組織の要約（プラン上限・使用量・契約状態）はほぼ全画面で必要なので、
 * 各画面が別々に取りに行かないよう 1 か所にまとめる。
 */
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { api } from './api.js';
import { qk } from './query-keys.js';
import type { CountedList, DomainSummary, OrgSummary } from './api-types.js';

export function useOrg(): UseQueryResult<OrgSummary> {
  return useQuery({
    queryKey: qk.org(),
    queryFn: () => api.get<OrgSummary>('/org'),
    staleTime: 30_000,
  });
}

/**
 * ドメイン一覧。件数が少ない（プランで 1〜20）ので `{items,total}` 形式で
 * 一括取得する（§4.3 の cursor 例外リストに含まれる）。
 */
export function useDomains(): UseQueryResult<CountedList<DomainSummary>> {
  return useQuery({
    queryKey: qk.domains(),
    queryFn: () => api.get<CountedList<DomainSummary>>('/domains'),
    staleTime: 30_000,
  });
}

/** 送信可能なドメイン（DNS 検証済み）だけを返す。メールボックス作成の選択肢に使う。 */
export function verifiedDomains(domains: DomainSummary[] | undefined): DomainSummary[] {
  return (domains ?? []).filter((d) => d.status === 'active');
}
